module.exports = __webpack_public_path__ + "static/media/edit.35089d58.svg";